import { render, staticRenderFns } from "./SettingsDropDownMenu.vue?vue&type=template&id=01128ab3&scoped=true&"
import script from "./SettingsDropDownMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsDropDownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01128ab3",
  null
  
)

export default component.exports